export default function IntroSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-1 h-12 bg-[#C9A961] rounded-full"></div>
              <h2 className="text-4xl font-bold text-[#1A1F2E]" style={{ fontFamily: 'Playfair Display, serif' }}>
                This Is Not Tourism — It's Relocation Travel
              </h2>
            </div>

            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p className="text-lg">
                <strong className="text-[#1A1F2E]">Relocating to Saudi Arabia is no longer just a career move</strong> — for many UK residents, it's a life transition. Professionals, families, and individuals are increasingly moving to cities such as <strong>Riyadh, Jeddah, Dammam</strong>, and emerging regions linked to <strong>Vision 2030</strong>, seeking long-term stability, opportunity, and lifestyle change.
              </p>

              <p>
                At Alwaz Travels, we specialise in <strong>Saudi relocation and long-stay travel services from the UK</strong>, offering personalised support that goes far beyond standard tourism bookings.
              </p>

              <p>
                Relocation travel sits between short-term travel and permanent migration. It involves <strong>uncertainty, flexibility, and careful planning</strong>. Online booking platforms are not designed for this type of journey — human advice is essential.
              </p>

              <p className="text-lg font-semibold text-[#1A1F2E]">
                Our role is to simplify the travel side of relocation, so you can focus on settling into your new life.
              </p>
            </div>

            <div className="mt-8 p-6 bg-[#C9A961]/10 border-l-4 border-[#C9A961] rounded-r-lg">
              <div className="flex items-start gap-3">
                <i className="ri-information-line text-2xl text-[#C9A961] mt-1"></i>
                <div>
                  <h3 className="font-bold text-[#1A1F2E] mb-2">Why Choose UK-Based Advisors?</h3>
                  <p className="text-gray-700 text-sm leading-relaxed">
                    UK residents consistently prefer UK-based travel advisors for relocation journeys. Clear pricing in GBP, familiar consumer protections, cultural clarity, and reliable after-sales support.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative h-[600px] w-full rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/7f4003caecb6f7d59b25bfa5a60d67cf.jpg"
                alt="Relocation Planning"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div className="absolute -bottom-6 -right-6 bg-white p-6 rounded-xl shadow-xl max-w-xs">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-12 h-12 flex items-center justify-center bg-[#C9A961]/10 rounded-full">
                  <i className="ri-shield-check-line text-2xl text-[#C9A961]"></i>
                </div>
                <div>
                  <div className="font-bold text-[#1A1F2E]">ATOL Protected</div>
                  <div className="text-sm text-gray-600">Your Journey Secured</div>
                </div>
              </div>
              <p className="text-sm text-gray-600">
                Full financial protection for your relocation travel arrangements
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
